<template>
  <div class="assess">
    <div class="container">
      <div class="card hoverable">
        <div class="card-image">
          <img src="@/assets/AfricaLogo1.jpg" />
        </div>
        <br />
        <br /><br />
        <div class="card-image">
          <img src="@/assets/Africa-sponsr.jpg" />
        </div>
      </div>

      <div class="card cardHello">
        <div class="card-content hoverable black-text">
          <h1>{{ subMsg }}</h1>
          <br /><br />
          <p>GENERAL NEEDS ASSESSMENT QUESTIONNAIRE</p>
          <br />
          <p style="color:red">All fields are required.</p>
        </div>
      </div>

      <form @submit.prevent="submit">
        <div class="card">
          <div class="card-content hoverable black-text">
            <ol>
              <li>
                What are your expectations at the end of the program?

                <textarea
                  id="textarea1"
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.program_end_expectations"
                  required
                ></textarea>
              </li>
              <br />
              <li>
                Where do you see yourself in the next 5 years?

                <textarea
                  id="textarea2"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.next_five_years"
                ></textarea>
              </li>
              <br />
              <li>
                How are you planning to achieve this?

                <textarea
                  id="textarea3"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.achievement_plan"
                ></textarea>
              </li>
              <br />
              <li>
                What are the likely challenges that you foresee facing achieving
                this great milestone?

                <textarea
                  id="textarea4"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.challenges_faced"
                ></textarea>
              </li>
              <br />
              <li>
                How do you plan on solving these challenge?

                <textarea
                  id="textarea5"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.solving_challenges"
                ></textarea>
              </li>
              <br />
              <li>
                What do you need to help you meet these goals?

                <textarea
                  id="textarea6"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.things_toHelp_achieve_goals"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Startup</span>
            <ol>
              <li>
                In a brief statement, describe your startup
                <textarea
                  id="textarea7"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.describe_startup"
                ></textarea>
              </li>
              <br />
              <li>
                What are your startup's goals and objectives?
                <textarea
                  id="textarea8"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.startup_goals_and_objectives"
                ></textarea>
              </li>
              <br />
              <li>
                Where do you see your startup in the next 5 years?
                <textarea
                  id="textarea9"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.forsee_startup_in_fiveYears"
                ></textarea>
              </li>
              <br />
              <li>
                How do you plan on achieving this milestone
                <textarea
                  id="textarea11"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.howTo_achieve_startup_milestone"
                ></textarea>
              </li>
              <br />
              <li>
                What are the likely challenges that might hinder your startup
                from achieving this goal?
                <textarea
                  id="textarea12"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.challengesTo_hinder_startup"
                ></textarea>
              </li>
              <br />
              <li>
                How are you working on solving this challenges?
                <textarea
                  id="textarea13"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.howTo_solve_startup_challenges"
                ></textarea>
              </li>
              <br />
              <li>
                What support do you need to help you reach your goals? State
                below.
                <textarea
                  id="textarea14"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.supported_neededTo_achieve_startup_goals"
                ></textarea>
              </li>
              <br />
              <li>
                Without any financial support will you be able to scale your
                solution?
                <textarea
                  id="textarea15"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.scale_solution_withNo_finance_support"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Business Model </span>
            <ol>
              <li>
                What problem is your business seeking to solve?
                <textarea
                  id="textarea16"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.business_problems_to_solve"
                ></textarea>
              </li>
              <br />
              <li>
                Do your business have a business model canvas?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.have_business_model_canvas"
                      class="with-gap"
                      name="businessModel1"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                If Yes, upload?
                <div class="file-field input-field">
                  <div class="btn">
                    <span>Upload File</span>
                    <input type="file" ref="myFiles" @change="file" />
                  </div>
                  <div class="file-path-wrapper">
                    <input
                      class="file-path validate"
                      v-model="form.business_model_canvas_file"
                      type="text"
                    />
                  </div>
                </div>
              </li>
              <li>
                If No, why?
                <textarea
                  id="textarea18"
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.no_business_model_canvas_explanation"
                ></textarea>
              </li>
              <br />
              <li>
                Do you have a business plan?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.do_youHave_business_plan"
                      class="with-gap"
                      name="businessPlan1"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                If Yes upload
                <div class="file-field input-field">
                  <div class="btn">
                    <span>Upload File</span>
                    <input type="file" ref="myFile2" @change="file2" />
                  </div>
                  <div class="file-path-wrapper">
                    <input
                      class="file-path validate"
                      v-model="form.has_business_plan_file"
                      type="text"
                    />
                  </div>
                </div>
              </li>
              <li>
                If No, why?

                <textarea
                  id="textarea20"
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.no_business_plan_explanation"
                ></textarea>
              </li>
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Marketing and Branding </span>
            <ol>
              <li>
                How well do you understand your market?

                <textarea
                  id="textarea01"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.how_you_understand_market"
                ></textarea>
              </li>
              <br />
              <li>
                What is your addressable market size?

                <textarea
                  id="textarea02"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.market_size"
                ></textarea>
              </li>
              <br />
              <li>
                Who are your target customers?

                <textarea
                  id="textarea03"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.target_customers"
                ></textarea>
              </li>
              <br />
              <li>
                Have you performed an initial market research?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.performed_initial_market_research"
                      class="with-gap"
                      name="market research"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                If yes tell us how, if no please state why
                <textarea
                  id="textarea05"
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.performed_initial_market_research_explanation"
                ></textarea>
              </li>
              <br />
              <li>
                Do you have a marketing strategy
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.do_you_have_marketing_strategy"
                      class="with-gap"
                      name="marketStrategy"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                If yes upload documents
                <div class="file-field input-field">
                  <div class="btn">
                    <span>Upload File</span>
                    <input type="file" ref="myFile1" @change="file1" />
                  </div>
                  <div class="file-path-wrapper">
                    <input
                      class="file-path validate"
                      v-model="form.marketing_strategy_file"
                      type="text"
                    />
                  </div>
                </div>
              </li>
              <li>
                If no state why

                <textarea
                  id="textarea07"
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.no_marketing_strategy_explanation"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Team </span>
            <ol>
              <li>
                What is your current team size?

                <textarea
                  id="textarea08"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.team_size"
                ></textarea>
              </li>
              <br />
              <li>
                Briefly state the qualification of each team member with respect
                to your startup

                <textarea
                  id="textarea09"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.team_members_qualification"
                ></textarea>
              </li>
              <br />
              <li>
                Will you say your current team has the capacity and capability
                to help you scale?

                <textarea
                  id="textarea"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.team_capacity"
                ></textarea>
              </li>
              <br />
              <li>
                How do you measure or monitor team performance?

                <textarea
                  id="textareas1"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.measure_for_team_performance"
                ></textarea>
              </li>
              <br />
              <li>
                What challenges do you currently face as a team hindering your
                ability to scale?

                <textarea
                  id="textareas2"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.challenges_faced_as_a_team"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Finance </span>
            <ol>
              <li>
                How do you currently finance your startup?

                <textarea
                  id="textareas3"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.how_startup_is_financed"
                ></textarea>
              </li>
              <br />
              <li>
                Have you raised any external funding since inception?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.any_external_funding"
                      class="with-gap"
                      name="fundExternal"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                If yes state how much and funding type
                <textarea
                  id="textareas5"
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.external_funding_explanation"
                ></textarea>
              </li>
              <br />
              <li>
                How much are you looking to raise in your next funding round?
                <textarea
                  id="textareas6"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.next_expected_funds_to_be_raised"
                ></textarea>
              </li>
              <br />
              <li>
                Have your fundraising campaigns been successful?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.have_fundraising_been_successful"
                      class="with-gap"
                      name="fundsucess"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                If No state why

                <textarea
                  id="textareas8" 
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.fundraising_not_successful_explanation"
                ></textarea>
              </li>
              <br />
              <li>
                How do you manage and report on your finances?
                <textarea
                  id="textareas9"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.how_finances_are_managed"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Others </span>
            <ol>
              <li>
                Do you have a board of directors?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.has_board_of_directors"
                      class="with-gap"
                      name="directors"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                Do you have an IP for your product?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.has_IP_for_products"
                      class="with-gap"
                      name="IP"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>

              <br />
              <li>
                What is the current state of your product development?
                <textarea
                  id="textareas12"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.state_of_product_development"
                ></textarea>
              </li>
              <br />
              <li>
                What tools and frameworks are you using to develop your product?
                <textarea
                  id="textareas13"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.frameworks_being_used"
                ></textarea>
              </li>
              <br />
              <li>
                How do you monitor product development growth?
                <textarea
                  id="textareas14"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.how_product_growth_is_monitored"
                ></textarea>
              </li>
              <br />
              <li>
                Provide your github repository to check your product codes?
                <textarea
                  id="textareas15"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.github_repo_link"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div class="card">
          <div class="card-content hoverable black-text">
            <span class="bold">Technical needs assessment </span>
            <ol>
              <li>
                What is the name of your model/ project?
                <textarea
                  id="textareas16"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.project_name"
                ></textarea>
              </li>
              <br />
              <li>
                What is your model trying to achieve?
                <textarea
                  id="textareas17"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.what_model_seeks_to_achieve"
                ></textarea>
              </li>
              <br />
              <li>
                What programming tools were used to train your model?

                <textarea
                  id="textareas18"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.programming_tools_used_to_model"
                ></textarea>
              </li>
              <br />
              <li>
                Have you deployed your model?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.has_model_been_deployed"
                      class="with-gap"
                      name="deployedModel"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                What stage is your model?

                <textarea
                  id="textareas20"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.model_stage"
                ></textarea>
              </li>
              <br />
              <li>
                Which platform is your model deployed?

                <textarea
                  id="textareas01"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.platform_model_is_deployed_to"
                ></textarea>
              </li>
              <br />
              <li>
                Do you know of IBM Watson services?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.knowledge_of_ibm_watson"
                      class="with-gap"
                      name="watson"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                <p>
                  How familiar are you with IBM Watson services?
                </p>
                <p>
                  <label>
                    <input
                      class="with-gap"
                      value="Not at all familiar"
                      v-model="form.how_familiar_are_you_with_watson"
                      name="grup1"
                      type="radio"
                      required
                    />
                    <span>Not at all familiar</span>
                  </label>
                </p>
                <p>
                  <label>
                    <input
                      class="with-gap"
                      value="Slightly familiar"
                      v-model="form.how_familiar_are_you_with_watson"
                      name="grup1"
                      type="radio"
                    />
                    <span>Slightly familiar</span>
                  </label>
                </p>
                <p>
                  <label>
                    <input
                      class="with-gap"
                      value="Moderately familiar"
                      v-model="form.how_familiar_are_you_with_watson"
                      name="grup1"
                      type="radio"
                    />
                    <span>Moderately familiar</span>
                  </label>
                </p>
                <p>
                  <label>
                    <input
                      class="with-gap"
                      value="Very familiar"
                      v-model="form.how_familiar_are_you_with_watson"
                      name="grup1"
                      type="radio"
                    />
                    <span>Very familiar</span>
                  </label>
                </p>
                <p>
                  <label>
                    <input
                      class="with-gap"
                      value="Extremely familiar  "
                      v-model="form.how_familiar_are_you_with_watson"
                      name="grup1"
                      type="radio"
                    />
                    <span>Extremely familiar </span>
                  </label>
                </p>
              </li>
              <br />
              <li>
                Which services of Watson have you used?

                <textarea
                  id="textareas04"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.watson_services_used"
                ></textarea>
              </li>
              <br />
              <li>
                What programming languages are you familiar with?

                <textarea
                  id="textareas05"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.familiar_programming_language"
                ></textarea>
              </li>
              <br />
              <li>
                What new programming languages would you like to learn/ use?

                <textarea
                  id="textareas06"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.new_programming_languages_you_want_to_use"
                ></textarea>
              </li>
              <br />
              <li>
                Can your model be easily integrated with other cloud services?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.can_model_be_easily_integrated"
                      class="with-gap"
                      name="integrated"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                Does it have offline capabilities?
                <div v-for="(bol, index) in options" :key="index">
                  <label>
                    <input
                      v-model="form.model_offline_capabilities"
                      class="with-gap"
                      name="capabilities"
                      :value="bol.value"
                      type="radio"
                      required
                    />
                    <span>{{ bol.text }}</span>
                  </label>
                </div>
              </li>
              <br />
              <li>
                What technical support do you need to successfully scale your
                services/ products?

                <textarea
                  id="textareas09"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.technical_support_needed_for_model"
                ></textarea>
              </li>
              <br />
              <li>
                What architecture is your product: SAAS, PAAS, ?

                <textarea
                  id="textareasc1"
                  required
                  placeholder="Answer"
                  class="materialize-textarea"
                  v-model="form.product_achitecture"
                ></textarea>
              </li>
              <br />
            </ol>
          </div>
        </div>

        <div id="buttons">
          <button type="submit" class="waves-effect waves-light btn">
            <router-link to="/">
              Back
            </router-link>
          </button>

          <button
            id="submit"
            type="submit"
            class="waves-effect waves-light btn"
            style="font-weight: bold;
  color: white;
  text-decoration: none;
  padding: 0 30px;"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

export default {
  data: function() {
    return {
      subMsg: "Baseline Survey - Africa AI Accelerator Program",
      options: [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" },
      ],
      form: {
        program_end_expectations: "",
        next_five_years: "",
        achievement_plan: "",
        challenges_faced: "",
        solving_challenges: "",
        things_toHelp_achieve_goals: "",
        describe_startup: "",
        startup_goals_and_objectives: "",
        forsee_startup_in_fiveYears: "",
        howTo_achieve_startup_milestone: "",
        challengesTo_hinder_startup: "",
        howTo_solve_startup_challenges: "",
        supported_neededTo_achieve_startup_goals: "",
        scale_solution_withNo_finance_support: "",
        business_problems_to_solve: "",
        have_business_model_canvas:"",
        business_model_canvas_file: "",
        no_business_model_canvas_explanation: "",
        do_youHave_business_plan: "",
        has_business_plan_file: "",
        no_business_plan_explanation: "",
        how_you_understand_market: "",
        market_size: "",
        target_customers: "",
        performed_initial_market_research: "",
        performed_initial_market_research_explanation: "",
        do_you_have_marketing_strategy: "",
        marketing_strategy_file: "",
        no_marketing_strategy_explanation: "",
        team_size: "",
        team_members_qualification: "",
        team_capacity: "",
        measure_for_team_performance: "",
        challenges_faced_as_a_team: "",
        how_startup_is_financed: "",
        any_external_funding: "",
        external_funding_explanation: "",
        next_expected_funds_to_be_raised: "",
        have_fundraising_been_successful: "",
        fundraising_not_successful_explanation: "",
        how_finances_are_managed: "",
        has_board_of_directors: "",
        has_IP_for_products: "",
        state_of_product_development: "",
        frameworks_being_used: "",
        how_product_growth_is_monitored: "",
        github_repo_link: "",
        project_name: "",
        what_model_seeks_to_achieve: "",
        programming_tools_used_to_model: "",
        has_model_been_deployed: "",
        model_stage: "",
        platform_model_is_deployed_to: "",
        knowledge_of_ibm_watson: "",
        how_familiar_are_you_with_watson: "",
        watson_services_used: "",
        familiar_programming_language: "",
        new_programming_languages_you_want_to_use: "",
        can_model_be_easily_integrated: "",
        model_offline_capabilities: "",
        technical_support_needed_for_model: "",
        product_achitecture: "",
      },
    };
  },
  methods: {
    file(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.form.business_model_canvas_file = e.target.result;
      }; 
    },
    file1(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.form.marketing_strategy_file = e.target.result;
      };
    },
    file2(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.form.has_business_plan_file = e.target.result;
      };
    },
    submit() {
      const info1 = JSON.parse(localStorage.getItem("push"));
      const info2 = this.form;
      const allInfo = { ...info1, ...info2 };
      this.allInfo = { info1, info2 };
      Object.keys(allInfo).forEach((key) => {
        if (allInfo[key] instanceof Array) {
          allInfo[key] = allInfo[key].toString();
        }
      });
      // console.log(this.allInfo);
      axios
        .post(
          "https://sxw70nfdmg.execute-api.us-east-1.amazonaws.com/prod/ai/response",
          JSON.stringify(this.allInfo)
        )
        .then((response) => {
          // if(response.status === 200) {
         // this.$router.push({ path: "/" });
          window.location = "https://africaaiaccelerator.com/";
          //}
          console.log(response + "successful");
        });
      Swal.fire({
        title: "Success!",
        text:
          "Thank you for completing this survey! Your response has been successfully sent. ",
        icon: "success",
        confirmButtonText: "Close",
      });
      event.target.reset();
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bolder;
}

ol {
  padding-left: 25px;
}

li {
  padding-left: 30px;
}

button {
  margin-right: 30px;
}

label {
  color: black !important;
}
</style>
